import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faBuilding, faUser } from "@fortawesome/free-regular-svg-icons";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import {
  Sidebar,
  SidebarBody,
  SidebarDivider,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
  SidebarTitle,
} from "./tailwind/sidebar";

export function SettingsSidebar({ children }) {
  const navigate = useNavigate();
  const selectedMenu = location.pathname.replace(/,/g, "/");
  const classLabel =
    "ml-6 hover:bg-grey rounded-customBorderRadius my-0 leading-3 pl-[2px]";

  return (
    <>
      <div className="flex h-full">
        <Sidebar className="w-60 border-r m-0 p-0 border-box h-full">
          <SidebarBody>
            <SidebarSection>
              <SidebarTitle>
                <FontAwesomeIcon icon={faWhatsapp} className=" text-base" />
                WhatsApp
              </SidebarTitle>
              <SidebarItem
                onClick={() => navigate("/settings/whatsapp/connexion")}
                current={selectedMenu === "/settings/whatsapp/connexion"}
                className={classLabel}
              >
                <SidebarLabel>Connexion</SidebarLabel>
              </SidebarItem>
              <SidebarItem
                onClick={() => navigate("/settings/whatsapp/business")}
                current={selectedMenu === "/settings/whatsapp/business"}
                className={classLabel}
              >
                <SidebarLabel>Business Profile</SidebarLabel>
              </SidebarItem>
              <SidebarItem
                onClick={() => navigate("/settings/whatsapp/awaymessage")}
                current={selectedMenu === "/settings/whatsapp/awaymessage"}
                className={classLabel}
              >
                <SidebarLabel>Away Message</SidebarLabel>
              </SidebarItem>
              <SidebarItem
                onClick={() => navigate("/settings/whatsapp/delivery-hours")}
                current={selectedMenu === "/settings/whatsapp/delivery-hours"}
                className={classLabel}
              >
                <SidebarLabel>Delivery Hours</SidebarLabel>
              </SidebarItem>
            </SidebarSection>

            <SidebarDivider />

            <SidebarSection>
              <SidebarTitle>
                <FontAwesomeIcon icon={faBuilding} className="text-base" />
                Company
              </SidebarTitle>

              <SidebarItem
                onClick={() => navigate("/settings/company/users")}
                current={selectedMenu === "/settings/company/users"}
                className={classLabel}
              >
                <SidebarLabel>Users</SidebarLabel>
              </SidebarItem>
              <SidebarItem
                onClick={() => navigate("/settings/company/notifications")}
                current={selectedMenu === "/settings/company/notifications"}
                className={classLabel}
              >
                <SidebarLabel>Notifications</SidebarLabel>
              </SidebarItem>

              <SidebarItem
                onClick={() => navigate("/settings/company/messages")}
                current={selectedMenu === "/settings/company/messages"}
                className={classLabel}
              >
                <SidebarLabel>Messages</SidebarLabel>
              </SidebarItem>

              {/* TODO: Add billing back in when we have a way to test it */}
              <SidebarItem
                onClick={() => navigate("/settings/company/billing")}
                current={selectedMenu === "/settings/company/billing"}
                className={classLabel}
              >
                <SidebarLabel>Billing</SidebarLabel>
              </SidebarItem>
            </SidebarSection>

            <SidebarDivider />
            <SidebarTitle>
              <FontAwesomeIcon icon={faDatabase} className="text-base" />
              Data
            </SidebarTitle>
            <SidebarItem
              onClick={() => navigate("/settings/data/integrations")}
              current={selectedMenu === "/settings/data/integrations"}
              className={classLabel}
            >
              <SidebarLabel>Integrations</SidebarLabel>
            </SidebarItem>

            <SidebarItem
              onClick={() => navigate("/settings/data/custom-fields")}
              current={selectedMenu === "/settings/data/custom-fields"}
              className={classLabel}
            >
              <SidebarLabel>Custom Fields</SidebarLabel>
            </SidebarItem>

            <SidebarItem
              onClick={() => navigate("/settings/data/tags")}
              current={selectedMenu === "/settings/data/tags"}
              className={classLabel}
            >
              <SidebarLabel>Tags</SidebarLabel>
            </SidebarItem>

            <SidebarItem
              onClick={() => navigate("/settings/data/imports")}
              current={selectedMenu === "/settings/data/imports"}
              className={classLabel}
            >
              <SidebarLabel>Imports</SidebarLabel>
            </SidebarItem>

            <SidebarItem
              onClick={() => navigate("/settings/data/exports")}
              current={selectedMenu === "/settings/data/exports"}
              className={classLabel}
            >
              <SidebarLabel>Exports</SidebarLabel>
            </SidebarItem>

            <SidebarItem
              onClick={() => navigate("/settings/data/coupon-codes")}
              current={selectedMenu === "/settings/data/coupon-codes"}
              className={classLabel}
            >
              <SidebarLabel>Coupon codes</SidebarLabel>
            </SidebarItem>

            <SidebarDivider />

            <SidebarSection>
              <SidebarTitle>
                <FontAwesomeIcon icon={faUser} className="text-base" />
                Profile
              </SidebarTitle>
              <SidebarItem
                onClick={() =>
                  navigate("/settings/profile/two-factor-authentication")
                }
                current={
                  selectedMenu === "/settings/profile/two-factor-authentication"
                }
                className={classLabel}
              >
                <SidebarLabel>2FA</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
          </SidebarBody>
        </Sidebar>
        <div className="flex flex-col w-full">{children}</div>
      </div>
    </>
  );
}
